import React, { useEffect, useState } from "react";
import logo from "assets/img/logo-light.png";
import * as Style from "./style";
import { Link } from "components/shared";

export default function Nav() {
    const [scrollY, setScrollY] = useState(0);

    const handleScroll = React.useCallback((e) => {
        setScrollY(window.scrollY);
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    return (
        <Style.NavMain scrollY={scrollY}>
            <Style.NavContainer>
                <Style.Logo href="#">
                    <img src={logo} alt="Norberto Ignacio Logo" />
                </Style.Logo>

                <Style.List>
                    <Style.Item>
                        <Link href="#skills">Skills</Link>
                    </Style.Item>
                    <Style.Item>
                        <Link href="#works">Works</Link>
                    </Style.Item>
                    <Style.Item>
                        <Link href="#about">About</Link>
                    </Style.Item>
                    <Style.Item>
                        <Link href="#contact">Contact</Link>
                    </Style.Item>
                </Style.List>
            </Style.NavContainer>
        </Style.NavMain>
    );
}
